import {
  useSelector,
  useTooltipSnapshot,
} from '../../../../core/components/overlay-tooltip/selectors.js';
import {
  UndefinedContent,
  type TooltipContent,
  type XYChartTooltipMetadata,
} from '../../../types/state.js';

const VariantToGeometryMap = {
  linear: new Set(['dot', 'line', 'area']),
  rectangle: new Set(['rect', 'bar']),
} as const;

const getPreferred = (
  metadata: unknown,
): TooltipContent | typeof UndefinedContent =>
  (metadata as XYChartTooltipMetadata)?.preferred ?? UndefinedContent;

const getDatapoints = (
  metadata: unknown,
  variant: 'linear' | 'rectangle',
): TooltipContent[] => {
  const all = (metadata as XYChartTooltipMetadata)?.datapoints;
  if (!all) {
    return [];
  }
  return all.filter((dp) =>
    VariantToGeometryMap[variant].has(dp.type),
  ) as TooltipContent[];
};

export const useTooltipMetadata = (
  variant: 'linear' | 'rectangle',
): TooltipContent[] => {
  useSelector(({ data }) => {
    const preferred = getPreferred(data?.metadata);
    const datapoints = getDatapoints(data?.metadata, variant);
    return { datapoint: preferred.datapoint, length: datapoints.length };
  });

  const { data } = useTooltipSnapshot();
  return getDatapoints(data.metadata, variant);
};
